/**
 * @generated SignedSource<<53ae1a9c3626951374ff04c628a3c03d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type createAxonIdentityProviderMutation$variables = {
  agencyDomain: string;
  connections: ReadonlyArray<string>;
  organizationNodeId: string;
};
export type createAxonIdentityProviderMutation$data = {
  readonly createAxonIdentityProvider: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly identityProviderConfiguration: {
      readonly axonConnectDomain: string | null;
      readonly id: string;
      readonly name: string;
      readonly providerType: identityprovidertype;
      readonly uuid: string;
    } | null;
  } | null;
};
export type createAxonIdentityProviderMutation = {
  response: createAxonIdentityProviderMutation$data;
  variables: createAxonIdentityProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agencyDomain"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationNodeId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "agencyDomain",
    "variableName": "agencyDomain"
  },
  {
    "kind": "Variable",
    "name": "organizationNodeId",
    "variableName": "organizationNodeId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "IdentityProviderConfiguration",
  "kind": "LinkedField",
  "name": "identityProviderConfiguration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "axonConnectDomain",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createAxonIdentityProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CreateAxonIdentityProvider",
        "kind": "LinkedField",
        "name": "createAxonIdentityProvider",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "createAxonIdentityProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CreateAxonIdentityProvider",
        "kind": "LinkedField",
        "name": "createAxonIdentityProvider",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "identityProviderConfiguration",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "IdentityProviderConfigurationEdge"
              }
            ]
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "502a0fa38aaa9ea16ef174a264459a1e",
    "id": null,
    "metadata": {},
    "name": "createAxonIdentityProviderMutation",
    "operationKind": "mutation",
    "text": "mutation createAxonIdentityProviderMutation(\n  $organizationNodeId: ID!\n  $agencyDomain: String!\n) {\n  createAxonIdentityProvider(organizationNodeId: $organizationNodeId, agencyDomain: $agencyDomain) {\n    identityProviderConfiguration {\n      id\n      uuid\n      name\n      providerType\n      axonConnectDomain\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "d961fc297e0810670b4802df55d62e1e";

export default node;
